import { useEffect } from "react";

export function useOutsideClick(ref, isOpen, onClose) {
  useEffect(() => {
    if (!isOpen) return;

    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        onClose();
      }
    };

    // capture phase = reliable
    window.addEventListener("click", handleClick, true);

    return () => {
      window.removeEventListener("click", handleClick, true);
    };
  }, [isOpen, ref, onClose]);
}